import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 0 30px 0px;
  padding-right: 30px;
  
  p{
    margin: 0;
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    margin-right: 5px;
  }

  label{

    input[type="checkbox"] {
      visibility: hidden;
    }

    input[type="checkbox"]:checked + span {
      background: #3E81F7;
      color: #fff;
    }

    span{
      width: auto;
      height: 26px;
      margin-left: 7px;
      text-align: center;
      padding: 5px;

      font-family: 'Roboto', sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;

      border: 1px solid #EEEEEE; 
      border-radius: 12px;

      :hover{
        background: #3E81F7;
        opacity: 0.5;
        color: #fff;
        cursor: pointer;
      }
    }
  }
`;
